import React from 'react';
import {
  Redirect,
  Route,
} from 'react-router-dom';
import { connect } from 'react-redux';


export const UnconnectedPrivateRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={(props) => {
      if (rest.authTokenUser && rest.authTokenUser.signUpCompleted) {
        return (
          <Component {...props} />
        );
      } else if (rest.authTokenUser) {
        return (
          <Redirect
            to={{
              pathname: '/sign-up',
              state: { next: props.location, continuingSignup: true },
            }}
          />
        );
      }
      return (
        <Redirect
          to={{
            pathname: '/login',
            state: { next: props.location },
          }}
        />
      );
    }}
  />
);


const mapStateToProps = ({ authTokenUser }) => ({
  authTokenUser,
});

export default connect(mapStateToProps)(UnconnectedPrivateRoute);



// WEBPACK FOOTER //
// ./src/components/PrivateRoute/index.js